module.exports = __webpack_public_path__ + "img/settings.0c97c72a.svg";